import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Eventos from './pages/Eventos';
import Contacto from './pages/Contacto';
import TableMenu from './pages/TableMenu';
import MesaMissingToken from './pages/MesaMissingToken';
import AdminLogin from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminInventory from './pages/admin/AdminInventory';
import AdminOrders from './pages/admin/AdminOrders';
import AdminTables from './pages/admin/AdminTables';
import AdminSettings from './pages/admin/AdminSettings';
import AdminInvoices from './pages/admin/AdminInvoices';
import AdminCashClose from './pages/admin/AdminCashClose';
import InvoicePrintView from './pages/admin/InvoicePrintView';
import CookieBanner from './components/CookieBanner';
import { AvisoLegal, BookingTerms, CookiesPolicy, PrivacyPolicy, UserDataDeletion } from './pages/LegalPages';

function PublicLayout() {
  return (
    <>
      <Navbar />
      <div className="neon-public-wrap"><Outlet /></div>
      <CookieBanner />
    </>
  );
}

function AdminGuard({ children, roles = ['admin', 'waiter', 'kitchen'] }) {
  const { user, isStaff } = useAuth();
  if (!isStaff) return <Navigate to="/admin/login" replace />;
  if (!roles.includes(user?.role)) return <Navigate to="/admin" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      {/* Rutas públicas con navbar principal */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/carta" element={<Menu />} />
        <Route path="/eventos" element={<Eventos />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
        <Route path="/eliminacion-datos" element={<UserDataDeletion />} />
        <Route path="/politica-cookies" element={<CookiesPolicy />} />
        <Route path="/condiciones-reservas" element={<BookingTerms />} />
      </Route>

      {/* Mesa QR — navbar propio con carrito */}
      <Route path="/mesa" element={<MesaMissingToken />} />
      <Route path="/mesa/:token" element={<TableMenu />} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/facturas/:id/print" element={<AdminGuard><InvoicePrintView /></AdminGuard>} />
      <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
        <Route index element={<AdminDashboard />} />
        <Route path="productos" element={<AdminGuard roles={['admin']}><AdminProducts /></AdminGuard>} />
        <Route path="inventario" element={<AdminGuard roles={['admin']}><AdminInventory /></AdminGuard>} />
        <Route path="pedidos" element={<AdminGuard roles={['admin']}><AdminOrders /></AdminGuard>} />
        <Route path="mesas" element={<AdminGuard roles={['admin']}><AdminTables /></AdminGuard>} />
        <Route path="facturas" element={<AdminGuard roles={['admin']}><AdminInvoices /></AdminGuard>} />
        <Route path="cierre-caja" element={<AdminGuard roles={['admin']}><AdminCashClose /></AdminGuard>} />
        <Route path="configuracion" element={<AdminGuard roles={['admin']}><AdminSettings /></AdminGuard>} />
      </Route>
    </Routes>
  );
}
